import React, { Component } from "react";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import { Link } from "react-router-dom";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import moment from "moment";
import API from "./../../../../../../../apiService";
import ALERT from "../../../../../../component/Alert";

const SignupSchema = Yup.object().shape({
  keyword: Yup.string().required("kata kunci harus diisi"),
  birth_date: Yup.date().required("tanggal lahir harus diisi"),
});

export default class SearchData extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: {
        keyword: "",
        birth_date: moment(new Date()).format("DD-MM-YYYY"),
        puskesmas_id: this.props.location.param
          ? this.props.location.param.data.code
          : "",
      },
      date: "",
      sel_date: new Date(),
      visit_date: moment(new Date()).format("DD-MM-YYYY"),
      clinic: [],
    };
    this.onChange = this.onChange.bind(this);
    this.post = this.post.bind(this);
    this.handleDate = this.handleDate.bind(this);
    this.handleVDate = this.handleVDate.bind(this);
  }
  componentDidMount() {
    if (this.props.location.param) {
    } else {
      this.props.history.push("/service/puskesmas");
    }
    this.getClinic();
    this.noRM.focus();
  }
  onChange(e) {
    let name = e.target.name;
    let value = e.target.value;
    this.setState((prevState) => ({
      data: {
        // object that we want to update
        ...prevState.data, // keep all other key-value pairs
        [name]: value,
      },
    }));
  }
  getClinic = async () => {
    let puskesmas_id = this.state.data.puskesmas_id;
    const res = await API.post("/standalone/clinic", { puskesmas_id });
    if (res.code == 200) {
      this.setState({ clinic: res.data });
    }
  };

  post = async () => {
    let param = {
      keyword: this.state.data.keyword,
      puskesmas_id: this.state.data.puskesmas_id,
      birth_date: moment(this.state.date).format("YYYY-MM-DD"),
    };
    const res = await API.post("/standalone/search", param);
    if (res.code == 200 && res.data !== null) {
      this.props.history.push({
        pathname: "/service/pilih-klinik",
        param: {
          puskesmas_id: this.state.data.puskesmas_id,
          id: res.data,
          clinic: this.state.clinic,
          profilpkm: this.props.location.param,
          name: res.patient_name,
          visit_date : moment(this.state.sel_date).format("YYYY-MM-DD"),
        },
      });
    } else {
      ALERT("error", "data tidak ditemukan");
    }
  };
  handleDate(date) {
    let datex = moment(date).format("YYYY-MM-DD");
    console.log(date);
    this.setState({ date: date });
    this.setState((prevState) => ({
      data: {
        // object that we want to update
        ...prevState.data, // keep all other key-value pairs
        birth_date: date,
      },
    }));
  }
  handleVDate(date) {
    let datex = moment(date).format("YYYY-MM-DD");
    console.log(date);
    this.setState({ sel_date: date });
    this.setState({ visit_date: datex });
  }
  render() {
    let datex = moment(this.state.data.birth_date).toDate();
    console.log(moment(new Date()).add(1, 'days')._d);
    
    return (
      <div className="main-content h-100vh">
        <div className="container-fluid">
          <div className="container">
            <div className="row align-item-center text-left">
              <div className="col-lg-12 my-lg-6">
                <h1 className="display-3 text-info">Pencarian Data</h1>
                <p className="lead">
                  Ketikan No/RM atau ktp dan tanggal lahir anda
                </p>
              </div>
            </div>
          </div>
        </div>
        <div className="container-fluid h-100vh pt-2  bg-white shadow-lg">
          <div className="container px-5">
            <div className="row">
              <div className="col pt-2">
                <div className="row col-md-12">
                  <Formik
                    enableReinitialize
                    initialValues={{
                      keyword: this.state.data.keyword,
                      birth_date: this.state.data.birth_date,
                      puskesmas_id: this.state.data.puskesmas_id,
                      visit_date: this.state.visit_date,
                    }}
                    validationSchema={SignupSchema}
                    onSubmit={(values) => {
                      // console.log(values);
                      this.post();
                    }}
                  >
                    {({ values, errors, touched }) => (
                      <Form>
                        <div className="form-group row">
                          <label
                            htmlFor="example-text-input"
                            className="col-md-5 col-form-label col-form-label-sm"
                          >
                            No RM / NIK
                          </label>
                          <div className="col-md-7">
                            <div className="row">
                              <input
                                className="form-control form-control-sm"
                                type="text"
                                placeholder="No Rekam Medis"
                                name="keyword"
                                id="keyword"
                                value={values.keyword}
                                onChange={this.onChange}
                                ref={(input) => {
                                  this.noRM = input;
                                }}
                              />
                              {errors.keyword && touched.keyword ? (
                                <div style={{ color: "red" }}>
                                  {errors.keyword}
                                </div>
                              ) : null}
                            </div>
                          </div>
                        </div>
                        <div className="form-group row">
                          <label
                            htmlFor="example-text-input"
                            className="col-md-5 col-form-label col-form-label-sm"
                          >
                            Tanggal lahir
                          </label>
                          <div className="col-md-7">
                            <div className="row">
                              <DatePicker
                                className="form-control col-md-12"
                                selected={this.state.date}
                                onChange={this.handleDate}
                                value={values.birth_date}
                                dateFormat="dd-MM-yyyy"
                                showMonthDropdown
                                showYearDropdown
                                dropdownMode="select"
                                autoComplete="nope"
                              />
                              {errors.birth_date && touched.birth_date ? (
                                <div style={{ color: "red" }}>
                                  {errors.birth_date}
                                </div>
                              ) : null}
                            </div>
                          </div>
                        </div>
                        <div className="form-group row">
                          <label
                            htmlFor="example-text-input"
                            className="col-md-5 col-form-label col-form-label-sm"
                          >
                            Rencana Berkunjung
                          </label>
                          <div className="col-md-7">
                            <div className="row">
                              <DatePicker
                                className="form-control col-md-12"
                                selected={this.state.sel_date}
                                onChange={this.handleVDate}
                                value={values.visit_date}
                                dateFormat="dd-MM-yyyy"
                                showMonthDropdown
                                showYearDropdown
                                dropdownMode="select"
                                autoComplete="nope"
                                minDate={new Date()}
                                maxDate={moment(new Date()).add('days', 1)._d}
                              />
                              {errors.birth_date && touched.birth_date ? (
                                <div style={{ color: "red" }}>
                                  {errors.birth_date}
                                </div>
                              ) : null}
                            </div>
                          </div>
                        </div>
                        <div>
                          <div className="row">
                            <div className="col-12">
                              <Link to="/service/puskesmas">
                                <button
                                  type="button"
                                  onClick={this.props.onHide}
                                  className="btn btn-outline-danger"
                                >
                                  kembali
                                </button>
                              </Link>
                              <button
                                type="submit"
                                className="btn btn-outline-primary"
                              >
                                Submit
                              </button>
                            </div>
                          </div>
                        </div>
                      </Form>
                    )}
                  </Formik>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
